export const dynamicKey = ({ text = "", year, month, contract,meta={} }) =>
  text
    .replace(/{{year}}/g, year)
    .replace(/{{month}}/g, month)
    .replace(/{{contract}}/g, contract)
    .replace(/{{prevYear}}/g, meta?.prevYear || "PY");
